"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniqueElementIds = exports.createCleanElementIds = void 0;

var createCleanElementIds = function createCleanElementIds(label) {
  return label !== undefined ? label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_') : undefined;
};

exports.createCleanElementIds = createCleanElementIds;

var createUniqueElementIds = function createUniqueElementIds(label) {
  return label !== undefined ? "".concat(label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_'), "_").concat(Math.random().toString().substring(2, 10)) : undefined;
};

exports.createUniqueElementIds = createUniqueElementIds;